export function createArray(arrayLength = 10): number[] {
  const array = []
  for (let i = 0; i < arrayLength; i++) {
    array[i] = i
  }
  return array
}
